import React, { useRef, useState } from "react";
import * as styles from "./ForgotPassword.module.css";
import { FloatingInput } from "../Inputs";
import {
  appConstants,
  passwordConfirmationValidate,
  passwordResetValidate,
} from "../../utils";
import * as constant from "../../utils/constants";
import { IQ_HUB_AUTH_SERVICES } from "../../services";
import { OTPWithResendSubmit } from "../OTPComponents";
import { showToast } from "../ToastComponent";
import FloatingPassword from "../Inputs/FloatingPassword";
import { useNavigate } from "react-router-dom";

export const ForgotPassword = () => {
  const emailRef = useRef();
  const passwordRef = useRef(null);
  const confirmPasswordRef = useRef(null);
  const navigate = useNavigate();

  const [isPasswordResetRequested, setIsPasswordResetRequested] =
    useState(false);
  const [isOTPVerified, setIsOTPVerified] = useState(false);
  const [initialRetryTime, setInitialRetryTime] = useState(0);
  const [IsPasswordResetLoading, setIsPasswordResetLoading] = useState(false);

  const handlePasswordReset = async () => {
    const payload = {
      password: passwordRef.current.value,
      confirmPassword: confirmPasswordRef.current.value,
    };
    const message = passwordConfirmationValidate(payload);
    if (message) {
      showToast(message);
      return;
    }
    setIsPasswordResetLoading(true);
    const response = await IQ_HUB_AUTH_SERVICES.ForgotPasswordResetConfirmation(
      payload
    );
    const forgotPasswordData = await response.json();
    showToast(forgotPasswordData?.message);
    setIsPasswordResetLoading(false);
    if (response.status !== 200) {
      console.log(forgotPasswordData);
    }
    switch (forgotPasswordData.message) {
      case "PASSWORD_RESET_SESSION_EXPIRED":
      case "PASSWORD_UPDATED": {
        navigate(constant.APP_ROUTE_LOGIN);
      }
    }
  };

  const handleSubmit = async () => {
    const payload = { email: emailRef.current.value };
    const message = passwordResetValidate(payload);
    if (message) {
      showToast(message);
      return;
    }
    setIsPasswordResetLoading(true);
    const response = await IQ_HUB_AUTH_SERVICES.ForgotPassword(payload);
    const forgotPasswordData = await response.json();
    if (!response.status !== 200) {
      setIsPasswordResetRequested(false);
    }
    switch (forgotPasswordData.message) {
      case "OTP_VERIFICATION_ALREADY_SENT":
      case "OTP_VERIFICATION_REQUIRED": {
        setIsPasswordResetRequested(true);
        setInitialRetryTime(forgotPasswordData.retryDuration);
        break;
      }
      default: {
        showToast(forgotPasswordData.message);
      }
    }
    showToast(forgotPasswordData.message);
    setIsPasswordResetLoading(false);
  };

  if (isOTPVerified) {
    return (
      <div>
        <h1 className={styles.sign_in_Heading}>Create new password</h1>
        <form
          onSubmit={(e) => {
            if (e.target.checkValidity()) {
              handlePasswordReset();
            }
            e.preventDefault();
          }}
        >
          <FloatingPassword ref={passwordRef} />

          <FloatingInput
            label="Confirm Password"
            name="confirmPassword"
            placeholder=""
            ref={confirmPasswordRef}
            type="password"
            required
          />

          <button type="submit" className={styles.submit_button}>
            {IsPasswordResetLoading ? "Loading..." : "Update Password"}
          </button>
        </form>
      </div>
    );
  }

  return (
    <div>
      {isPasswordResetRequested ? (
        <OTPWithResendSubmit
          initialRetryTime={initialRetryTime}
          otpVerifyAPI={IQ_HUB_AUTH_SERVICES.ForgotPasswordVerifyOtp}
          otpResendAPI={IQ_HUB_AUTH_SERVICES.ForgotPasswordResendOtp}
          onOTPVerified={() => {
            setIsOTPVerified(true);
          }}
        />
      ) : (
        <>
          <h1 className={styles.sign_in_Heading}>Forgot Your Password</h1>
          <form
            onSubmit={(e) => {
              if (e.target.checkValidity()) {
                handleSubmit();
              }
              e.preventDefault();
            }}
          >
            <FloatingInput
              label="Email"
              name="email"
              placeholder=""
              ref={emailRef}
              type="email"
              required
            />
            <button type="submit" className={styles.submit_button}>
              {IsPasswordResetLoading ? "Loading..." : "Send OTP >"}
            </button>
          </form>
        </>
      )}
    </div>
  );
};
